import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { style } from '@angular/animations';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-inputTextArea',
  templateUrl: './inputTextArea.component.html',
  styleUrls: ['./inputTextArea.component.css'],
  viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ]

})
export class InputTextAreaComponent implements OnInit {
  showErrorMessage=false;
  options: any[] = [];
  @Input() label: String;
  @Input() apiService: any;
  @Input() maxlength:any;
  @Input() minlength:any;
  @Input() pattern:any;
  @Input() name:any;
  @Input() required:boolean = false;
  @Input() model:any;
  @Input() style:any
  @Input() showError(bool){
    this.showErrorMessage=bool;
  };
  @Output() onModelChange = new EventEmitter<number>();
  formName: string = '';
  labelName :String='';
  requiredProperty:boolean=false;
  errorMesage:any;

  constructor() { }
  ngOnInit() {
    this.formName = this.name ;
    this.requiredProperty= this.required;
    this.labelName= this.requiredProperty ? this.label+'*': this.label;

  }
  modelChange($event) {
    this.onModelChange.emit($event);
  }
}